<template>
	<div>
		<!-- v-if="!multiple" -->
		<v-text-field
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			:rules="rules"
			:value="value"
			:name="param.name"
			@update:error="errored = $event"
			clearable
			@input="$emit('update:value', $event)"
			:readonly="readonly">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>
		</v-text-field>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import Hint from '@/components/fields/hint.vue'
import Label from '@/components/fields/label.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false
		}
	},
	computed: {
		multiple () {
			return this.param.type.indexOf('multi-char') === 0
		}
	},
	methods: {
		requiredCheck (value) {
			if (value === '') return 'Requis char'
			if (value === null) return 'Requis char'
			if (value === undefined) return 'Requis char'
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/char.vue